import moment from 'moment';
import { stringify } from 'qs';
import { getWsSignature, getHttpSignature } from './paasSignature';

export const createWsClient = (api, params = {}) => {
  const access_key_id = '443201917';
  const accessKeySecret = '9M17PjVGZSbWSp5nHLJXvc2BLXwU30aK';
  const timestamp = moment(new Date())
    .utcOffset(480)
    .format('YYYY-MM-DDTHH:mm:ss');
  const { signature, signatureNonce } = getWsSignature(
    {
      access_key_id,
      timestamp,
      ...params
    },
    accessKeySecret
  );
  const searchStr = stringify(
    {
      access_key_id,
      signature,
      signature_nonce: signatureNonce,
      timestamp,
      ...params
    },
    { encode: true }
  );
  return new WebSocket(`${api}?${searchStr}`);
};

export const calculateAuthUrl = (url, requestMethod, bodyParams, urlParams) => {
  const contentType = 'application/json';
  const timestamp = moment(new Date())
    .utcOffset(480)
    .format('YYYY-MM-DDTHH:mm:ss');
  const access_key_id = '443201917';
  const accessKeySecret = '9M17PjVGZSbWSp5nHLJXvc2BLXwU30aK';
  const { signature, signatureNonce } = getHttpSignature(
    { access_key_id, timestamp, ...urlParams },
    bodyParams,
    requestMethod,
    contentType,
    accessKeySecret
  );
  const searchStr = stringify(
    {
      access_key_id,
      signature,
      signature_nonce: signatureNonce,
      timestamp,
      ...urlParams
    },
    {
      encode: true
    }
  );
  return `${url}?${searchStr}`;
};
